import { Grid, Stack } from "@mui/material";

const FormWrapperRegister = ({ children }) => {
  return (
    <Grid container alignItems="center" justifyContent="center">
      <Grid item xs={4} position="fixed" left="0" top="0" width="100%" height="100%">
        <img
          src="/static/images/AVC_SIGNUP.jpg"
          alt="login"
          height="100%"
          width="100%"
          style={{ objectFit: "cover" }}
        />
      </Grid>
      <Grid item xs={8} right="0" top="0" position="absolute" width="100%">
        <Stack width="100%" sx={{ height: "100vh" }} py={4} justifyContent="flex-start" alignItems="center">
          <Stack spacing={6} py={6} width="100%" justifyContent="center" alignItems="center">
            {children}
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default FormWrapperRegister;
